import api from '@/utils/api';
import { toOptionalSearch } from '@/utils/service';

export interface StockSummaryCardApi {
  key: string;
  label: string;
  value: number;
}

export type StockRequestStatusUpdate = 'PROCESS' | 'COMPLETE' | 'CANCELLED' | 'DISPATCH';

export interface StockRequestApiItem {
  id: string;
  sourceType: string;
  userId: string;
  userName: string;
  userEmail: string;
  phoneNumber?: string | null;
  address?: string | null;
  operationType: string;
  operationLabel: string;
  productId: string;
  productName: string;
  quantity: string | null;
  priceUnit?: string | null;
  amount: string | null;
  city?: string | null;
  pincode?: string | null;
  status: string;
  statusLabel: string;
  upiId?: string | null;
  bankDetails?: string | null;
  paymentQrCode?: string | null;
  exchangeRatio?: string | null;
  cancellationReason?: string | null;
  createdAt: string;
  updatedAt: string;
}

export interface StockRequestsResponse {
  summary: {
    cards: StockSummaryCardApi[];
    totalRequests: number;
    buyRequests: number;
    sellRequests: number;
    exchangeRequests: number;
    activeRequests: number;
  };
  total: number;
  page: number;
  limit: number;
  requests: StockRequestApiItem[];
}

export async function fetchStockRequests(page = 1, limit = 20, search?: string, startDate?: string, endDate?: string): Promise<StockRequestsResponse> {
  const res = await api.get<StockRequestsResponse>('/proxy/product-requests', {
    params: {
      page,
      limit,
      search: toOptionalSearch(search),
      ...(startDate && { startDate }),
      ...(endDate && { endDate }),
    },
  });

  return res.data;
}

export async function updateStockRequestStatus(
  requestId: string,
  status: StockRequestStatusUpdate,
  sourceType = 'request',
  cancellationReason?: string
): Promise<void> {
  const body: Record<string, string> = {
    status,
    sourceType,
  };

  if (status === 'CANCELLED' && cancellationReason?.trim()) {
    body.cancellationReason = cancellationReason.trim();
  }

  await api.patch(`/proxy/product-requests/${requestId}/status`, body);
}
